export default __webpack_public_path__ + "static/media/Arrow.2bd14830.png";